module.exports = __webpack_public_path__ + "img/user1.2b939b5e.png";